<app-picture-selection [availablePictures]="availablePictures()" [(selectedPictureKeys)]="selectedPictureKeys"
    [notificationMessage]="notificationMessage()" (stop)="goToPreviousScreen()">
</app-picture-selection>